import {
  Currency,
  Language,
  Locales,
} from '@/utils/translations/types/TypeLanguagesAndLocales';

export function getLanguageFromLocale(locale?: string) {
  switch (locale) {
    case Locales.StandardDutch:
      return Language.Dutch;
    case Locales.StandardFrench:
      return Language.French;
    case Locales.StandardGerman:
      return Language.German;
    case Locales.StandardSpanish:
      return Language.Spanish;
    case Locales.UnitedStatesEnglish:
    case Locales.UnitedKingdomEnglish:
    case Locales.AustralianEnglish:
    case Locales.EuropeanEnglish:
    default:
      return Language.English;
  }
}

export function getCurrencyFromLocale(locale?: string) {
  switch (locale) {
    case Locales.StandardDutch:
      return Currency.EUR;
    case Locales.StandardFrench:
      return Currency.EUR;
    case Locales.StandardGerman:
      return Currency.EUR;
    case Locales.StandardSpanish:
      return Currency.EUR;
    case Locales.UnitedKingdomEnglish:
      return Currency.GBP;
    case Locales.EuropeanEnglish:
      return Currency.EUR;
    case Locales.UnitedStatesEnglish:
      return Currency.USD;
    case Locales.AustralianEnglish:
      return Currency.AUD;
    default:
      return Currency.USD;
  }
}
